export interface Neo4jQuerys {
  AT_37_default_search_match_customer: string;
  AT_37_default_search_match_account: string;
  AT_37_default_search_match_case: string;
  AT_37_search_match_customer: string;
  AT_37_search_match_account: string;
  AT_37_search_match_case: string;
  AT_37_initial_match: string;
  AT_37_match_account: string;
  AT_37_match_accounts_with_CI: string;
  AT_37_match_transfers_with_account: string;
  AT_37_match_customer_with_account: string;
  AT_37_match_transfers_and_accounts_by_CI: string;
  AT_37_match_2best_transfers_by_account_by_CI: string;
  AT_37_match_cases_of_customer: string;
  AT_37_match_customer_of_case: string;

  AN_full_text_search: string;
  AN_default_search_cases: string;
  AN_search_cases: string;
  AN_case_search_users: string;
  AN_search_tasks: string;
  AN_case_search_case_type: string;
}

export function InitQuerys(search_term: string): Neo4jQuerys {
  const neo4jQuerys = {} as Neo4jQuerys

  neo4jQuerys.AT_37_default_search_match_customer = `
    MATCH (c:Customer) RETURN c LIMIT 10
  `
  neo4jQuerys.AT_37_default_search_match_account = `
    MATCH (c:Account) RETURN c LIMIT 10
  `
  neo4jQuerys.AT_37_default_search_match_case = `
    MATCH (c:case) RETURN c LIMIT 10
  `

  neo4jQuerys.AT_37_search_match_customer = `
    match (c:Customer) WHERE c.Nombre =~ '(?i).*${search_term}.*' OR c.id =~ '(?i).*${search_term}.*' RETURN c LIMIT 10
  `

  neo4jQuerys.AT_37_search_match_account = `
    match (c:Account) WHERE c.Nombre =~ '(?i).*${search_term}.*' OR c.id =~ '(?i).*${search_term}.*' RETURN c LIMIT 10
  `

  neo4jQuerys.AT_37_search_match_case = `
    match (c:case) WHERE c.gai =~ '(?i).*${search_term}.*' OR c.numero_de_identificacion =~ '(?i).*${search_term}.*' RETURN c LIMIT 10
  `

  neo4jQuerys.AT_37_initial_match = `
    match (c:Customer) RETURN c LIMIT 30
  `
  neo4jQuerys.AT_37_match_account = `
    match (c1:Customer) WHERE c1.id = '${search_term}' RETURN c1
  `
  neo4jQuerys.AT_37_match_accounts_with_CI = `
    match (c1:Customer)-[r:HAS_ACCOUNT]->(a:Account) WHERE c1.id = '${search_term}' RETURN c1,r,a
  `

  neo4jQuerys.AT_37_match_transfers_with_account = `
    MATCH (a1:Account {id: '${search_term}'})-[r:HAS_TRANSFERED]-(a2:Account)
    RETURN a1, r, a2
    UNION
    MATCH (a1:Account)-[r:HAS_TRANSFERED]-(a2:Account {id: '${search_term}'})
    RETURN a1, r, a2
  `

  neo4jQuerys.AT_37_match_customer_with_account = `
    match (c:Customer)-[r:HAS_ACCOUNT]->(a:Account {id:'${search_term}'}) RETURN c,r,a
  `

  neo4jQuerys.AT_37_match_transfers_and_accounts_by_CI = `
    match (c1:Customer {id:'${search_term}'})-[r:HAS_ACCOUNT]->(a:Account)-[r2:HAS_TRANSFERED]->(a2:Account)
    RETURN c1, a, r, r2, a2
    UNION
    match (c1:Customer {id:'${search_term}'})-[r:HAS_ACCOUNT]->(a:Account)<-[r2:HAS_TRANSFERED]-(a2:Account)
    RETURN c1, a, r, r2, a2
  `

  neo4jQuerys.AT_37_match_2best_transfers_by_account_by_CI = `
    match (c1:Customer {id:'${search_term}'})-[r:HAS_ACCOUNT]->(a:Account)-[r2:HAS_TRANSFERED]->(a2:Account)
    RETURN c1, a, r, r2, a2
    ORDER BY r2.transfer_amount DESC
    UNION
    match (c1:Customer {id:'${search_term}'})-[r:HAS_ACCOUNT]->(a:Account)<-[r2:HAS_TRANSFERED]-(a2:Account)
    RETURN c1, a, r, r2, a2
    ORDER BY r2.transfer_amount DESC
    LIMIT 2
  `

  neo4jQuerys.AT_37_match_cases_of_customer = `
    MATCH (c:Customer {id: '${search_term}'})-[r:HAS_CASE]->(case:case)
    RETURN c, case, r
  `

  // Analytiko queries
  neo4jQuerys.AN_default_search_cases = `
    MATCH (c:case) 
    WHERE c.numero_de_identificacion <> '' AND c.numero_de_identificacion CONTAINS '${search_term}' 
    RETURN c
  `
  neo4jQuerys.AN_search_cases = `
    MATCH (c:case) 
    WHERE c.numero_de_identificacion <> '' AND c.numero_de_identificacion CONTAINS '${search_term}' 
    RETURN c
  `
  neo4jQuerys.AN_case_search_users = `
    match (c:case {_id: '${search_term}'})-[r:ONE_TO_ONE]->(u:user) return c,r,u
  `
  neo4jQuerys.AN_search_tasks = `
    MATCH (t:Task) WHERE t.title CONTAINS '${search_term}' RETURN t
  `

  neo4jQuerys.AN_case_search_case_type = `
    match (c:case {_id: '${search_term}'})-[r:ONE_TO_ONE]->(ct:case_type) return c,r,ct
  `

  neo4jQuerys.AN_full_text_search = `
    MATCH (n)-[r]-() WHERE ANY (prop IN keys(n) WHERE toLower(toString(n[prop])) CONTAINS toLower('${search_term}')) RETURN n,r
  `

  return neo4jQuerys
}